// extracted by mini-css-extract-plugin
export var container = "_2g-0";
export var error = "_2g-9";
export var label = "_2g-5";
export var light = "_2g-6";
export var md = "_2g-3";
export var sm = "_2g-2";
export var thin = "_2g-8";
export var thinBold = "_2g-7";
export var vertical = "_2g-4";
export var xs = "_2g-1";